export default {
    URBANA: 1,
    RURAL: 2,
}